export default __webpack_public_path__ + "static/media/BlueVector-down.b446ae51.svg";